import { IdT } from '../interfaces/tid';
import { CacheService } from './cache.service';
import { IBaseServiceAsync } from './ibase-async.service';
import { BaseService } from './base.service';
import { Page } from '../models/pagination';
import { Axios } from 'axios';

export abstract class BaseServiceAsyncT<Id, T> extends BaseService implements IBaseServiceAsync<Id, T> {  
  constructor(    
    protected axios: Axios,
    protected cacheService: CacheService,
    protected url: string) {
      super();
      this.checkCacheAge();
  }

  public getAllAsync(currentpage: number = 1, pagesize: number = 500, url?: string): Promise<Page<T> | T[]> {
    const prom = new Promise<Page<T> | T[]>((res, reject) => {
      let apiurl = this.pagedUrl(this.url, currentpage, pagesize);      
      if (url) {
        apiurl = this.pagedUrl(url, currentpage, pagesize);        
      }
      // this.cacheService.invalidateAll();
      const cached: any = this.cacheService.get(apiurl);
      if (cached !== undefined) {
        res(cached as T[]);
      }
      else {
        this.axios.get<T[]>(apiurl)
          .then(
            resp => {
              if (resp.headers['x-pagination']) {                
                const pagination = JSON.parse(resp.headers['x-pagination']);
                const paged: Page<T> = pagination as Page<T>;                
                paged.items = resp.data;
                if (resp !== undefined && this.doCache) {
                  this.cacheService.put(apiurl, paged);
                }
                res(paged);
              }
              else {                
                if (resp !== undefined && this.doCache) {
                  this.cacheService.put(apiurl, resp.data);
                }
                res(resp.data);
              }
            })
          .catch(err => {
            reject(this.createHtppError(err));
          });
      }
    });
    return prom;
  }

  public getByIdsAsync(id: Id[], currentpage?: number, pagesize?: number, url?: string): Promise<Page<T> | T[]> {
    const prom = new Promise<Page<T> | T[]>((res, reject) => {
      let ids!: string;

      for (const i of id) {
        if (!ids) {
          ids = `id=${i}`;
        }
        else {
          ids += `&id=${i}`;
        }
      }

      let apiurl = `${this.url}/By/Ids?${ids}`;
      apiurl = this.pagedUrl(apiurl, currentpage, pagesize);

      if (url) {
        apiurl = this.pagedUrl(url, currentpage, pagesize);        
      }
      const cached: any = this.cacheService.get(apiurl);

      if (cached !== undefined) {
        res(cached as T[]);
      }
      else {
        this.axios.get(apiurl)
          .then(
            resp => {
              if (resp.headers['x-pagination']) {
                const pagination = JSON.parse(resp.headers['x-pagination']);
                const paged: Page<T> = pagination as Page<T>;
                paged.items = resp.data;
                if (resp !== undefined && this.doCache) {
                  this.cacheService.put(apiurl, paged);
                }
                res(paged);
              }
              else {
                if (resp !== undefined && this.doCache) {
                  this.cacheService.put(apiurl, resp.data);
                }
                res(resp.data);
              }
            })
          .catch(err => {

            reject(this.createHtppError(err));
          });
      }
    });
    return prom;
  }

  public getAsync(id: Id, url?: string): Promise<T> {
    const prom = new Promise<T>((res, reject) => {
      let apiurl = `${this.url}/${id}`;
      if (url) {
        apiurl = url;
      }
      const cached: any = this.cacheService.get(apiurl);

      if (cached !== undefined) {
        res(cached as T);
      } else {
        this.axios.get(apiurl)
          .then(
            resp => {
              if (resp !== undefined && this.doCache) {
                this.cacheService.put(apiurl, resp.data);
              }
              res(resp.data);
            }).catch(err => {
              reject(this.createHtppError(err));
            });
      }
    });
    return prom;
  }

  public getAsyncArray(id: Id, url?: string): Promise<T[]> {
    const prom = new Promise<T[]>((res, reject) => {
      let apiurl = `${this.url}/${id}`;
      if (url) {
        apiurl = url;
      }
      const cached: any = this.cacheService.get(apiurl);

      if (cached !== undefined) {
        res(cached as T[]);
      } else {        
        this.axios.get(apiurl)
          .then(
            resp => {
              if (resp !== undefined && this.doCache) {
                this.cacheService.put(apiurl, resp.data);
              }
              res(resp.data);
            }).catch(err => {
              reject(this.createHtppError(err));
            });
      }
    });
    return prom;
  }

  public getAsyncWithCode(id: Id, url?: string): Promise<T> {
    const prom = new Promise<T>((res, reject) => {     
      let apiurl = `${this.url}/${id}`;
      if (url) {
        apiurl = url;
      }
      const cached: any = this.cacheService.get(apiurl);

      if (cached !== undefined) {
        res(cached as T);
      } else {
        this.axios.get(apiurl)
          .then(
            resp => {
              if (resp !== undefined && this.doCache) {
                this.cacheService.put(apiurl, resp.data);
              }
              res(resp.data);
            }).catch(err => {
              reject(this.createHtppError(err));
            });
      }
    });
    return prom;
  }

  public getAsyncByOwningID(id: Id, url?: string): Promise<T> {
    const prom = new Promise<T>((res, reject) => {
      
      let apiurl = `${this.url}/by/owningId/${id}`;
      if (url) {
        apiurl = url;
      }
      const cached: any = this.cacheService.get(apiurl);

      if (cached !== undefined) {
        res(cached as T);
      } else {
        this.axios.get(apiurl)
          .then(
            resp => {
              if (resp !== undefined && this.doCache) {
                this.cacheService.put(apiurl, resp.data);
              }
              res(resp.data);
            }).catch(err => {
              reject(this.createHtppError(err));
            });
      }
    });
    return prom;
  }
  
  public getAsyncByOwningIDArray(id: Id, url?: string): Promise<T[]> {
    const prom = new Promise<T[]>((res, reject) => {
      
      let apiurl = `${this.url}/by/owningId/${id}`;
      if (url) {
        apiurl = url;
      }
      const cached: any = this.cacheService.get(apiurl);

      if (cached !== undefined) {
        res(cached as T[]);
      } else {                
        this.axios.get(apiurl)
          .then(
            resp => {
              if (resp !== undefined && this.doCache) {
                this.cacheService.put(apiurl, resp.data);
              }
              res(resp.data);
            }).catch(err => {
              reject(this.createHtppError(err));
            });
      }
    });
    return prom;
  }

  public getAnyAsync<K>(): Promise<K> {
    const prom = new Promise<K>((res, reject) => {
      let apiurl = `${this.url}`;
      if (this.url) {
        apiurl = this.url;
      }
      const cached: any = this.cacheService.get(apiurl);

      if (cached !== undefined) {
        res(cached as K);
      } else {
        this.axios.get(apiurl)
          .then(
            resp => {
              if (resp !== undefined && this.doCache) {
                this.cacheService.put(apiurl, resp.data);
              }
              res(resp.data);
            }).catch(err => {
              reject(this.createHtppError(err));
            });
      }
    });
    return prom;
  }

  public getDetails<K>(id: Id): Promise<K> {
    const prom = new Promise<K>((res, reject) => {
      const apiurl = `${this.url}/${id}/details`;
      const cached: any = this.cacheService.get(apiurl);

      if (cached !== undefined) {
        res(cached as K);
      } else {
        this.axios.get(apiurl)
          .then(
            resp => {
              if (res !== undefined && this.doCache) {
                this.cacheService.put(apiurl, resp);
              }              
              res(resp.data);
            }).catch(err => {
              reject(this.createHtppError(err));
            });
      }
    });
    return prom;
  }

  private isId(arg: any): arg is IdT<Id> {
    return arg.id !== undefined;
  }

  public update(entity: T, id?: Id, url?: string): Promise<T> {
    this.cacheService.invalidateAll();
    const prom = new Promise<T>((res, reject) => {
      let apiurl = url || this.url;
      if (id) {
        apiurl = `${apiurl}/${id}`;
      }
      else if (this.isId(entity)) {
        const entityid = (entity as any as (IdT<Id>)).id;
        apiurl = `${apiurl}/${entityid}`;
      }
      this.axios.put(apiurl, entity)
        .then(
          resp => {
            res(entity);
          }).catch(err => {
            reject(this.createHtppError(err));
          });
    });
    return prom;
  }

  public add(entity: T, url?: string): Promise<T> {
    this.cacheService.invalidateAll();
    const prom = new Promise<T>((res, reject) => {
      const apiurl = url || this.url;
      this.axios.post(apiurl, entity)
        .then(
          resp => {            
            res(resp.data);
          }).catch(err => {
            reject(this.createHtppError(err));
          });
    });
    return prom;
  }

  public delete(id: Id, url?: string): Promise<Id> {
    const prom = new Promise<Id>((res, reject) => {
      let apiurl = `${this.url}/${id}`;
      if (url) {
        apiurl = url;
      }
      
      this.axios.delete(apiurl)
        .then(
          resp => {
            res(id);
          }).catch(err => {
            reject(this.createHtppError(err));
          });
    });
    return prom;
  }

  public checkCacheAge(){
    const cacheAge = localStorage.getItem('cacheAge');
    if(cacheAge){
      const currentDate = new Date();
      const dateCachedMilliSeconds = parseInt(cacheAge);
      const currentDateMilliSeconds = currentDate.getTime();
      const diff = currentDateMilliSeconds - dateCachedMilliSeconds;
      const timeDiff = (diff / 1000) / 60;      
      
      if(timeDiff > 60){
        this.cacheService.invalidateAll();
        localStorage.setItem('cacheAge', JSON.stringify(currentDate.getTime()));
      }
    } else{
      const currentDate = new Date();
      localStorage.setItem('cacheAge', JSON.stringify(currentDate.getTime()));
    }    
  }
}
